const part = [
    {
        path: 'notice-management-list',
        name: 'notice-management-list',
        meta: {
            icon: 'md-people',
            title: '公告管理',
            notCache: true,
            access: ['S'],
            items: [
            ]
        },
        component: () => import('@/view/system-management/notice-management/notice-list')
    }
];

export default part;
